function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import cn from 'classnames';
import ChevronRight from 'svg/chevron-right.svg';
import styles from './GoToArrow.pcss';
var _React_Component;
class GoToArrow extends (_React_Component = React.Component) {
    render() {
        return /*#__PURE__*/ _jsx(ChevronRight, {
            className: cn(styles.goToButton__arrow, this.props.className, {
                [styles['goToButton__arrow--back']]: this.props.isBack
            })
        });
    }
}
_define_property(GoToArrow, "propTypes", {
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    isBack: PropTypes.bool
});
_define_property(GoToArrow, "defaultProps", {
    isBack: false
});
export default withStyles(styles)(GoToArrow);
